import React, {useImperativeHandle, useRef, useEffect, forwardRef, useState} from "react";
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import { useSelector } from "react-redux";
import HttpAPICall from "../../../services/HttpAPICall";
import { toast } from "react-toastify";
import TapIcon from "../../../services/TapIcon";
import { HRM_API_BASE_URL_2 } from "../../../services/TapApiUrls";

const HrmActivationModal = forwardRef((props, ref) => {
    const access_token                =     useSelector(state => state.auth.access_token);
    const modalElem                   =     useRef(null);
    const searchModal                 =     useRef(null);
    const modalID                     =     uuid();
    const hrmUrl                      =     HRM_API_BASE_URL_2 + '/employee_hrm_activation';

    const [formData, setFormData]           =       useState({
                                                                 employee_name           : "",
                                                                 employee_code           : "",
                                                                 mobile                  : "",
                                                                 username                : "",
                                                                 password                : "",
                                                                 password_confirmation   : "",
                                                                 employee_id             : ""
                                                             });

    const [showPassword, setShowPassword]               = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isSubmitting, setIsSubmitting]               = useState(false);

    useEffect(() => {    
        modalElem.current = document.getElementById(modalID);
        searchModal.current = new Modal(modalElem.current, {keyboard: false, backdrop: false});
        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
        };
    }, []);

    useImperativeHandle(ref, () => ({
        initModalHandler: (employeeData) => {
            if (employeeData) {
                const hasExistingUsername = employeeData?.username && employeeData.username !== "";
                setFormData({
                    employee_name           :   employeeData?.display_full_name || "",
                    employee_code           :   employeeData?.employee_code || "",
                    mobile                  :   employeeData?.mobile || "",
                    username                :   hasExistingUsername ? employeeData?.username : "",
                    password                :   "",
                    password_confirmation   :   "",
                    employee_id             :   employeeData?.enc_id || ""
                });
            }
            openModalHandle();
        }
    }));

    const searchModalOpen = () => searchModal.current && searchModal.current.show();
    const searchModalClose = () => {
        searchModal.current && searchModal.current.hide();
        resetForm();
    };

    const openModalHandle = () => {
        searchModalOpen();       
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit =  (e) => {
        e.preventDefault();
        if (formData.password !== formData.password_confirmation) {
            toast.error("Password and Confirm Password do not match", {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }
        setIsSubmitting(true);
        const payload = { ...formData };
        HttpAPICall.withAthorization("POST", hrmUrl, access_token, {}, payload, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            searchModalClose();
            if (props.onSuccess) {
                props.onSuccess();
            }
        }
        ).then(() => {
            setIsSubmitting(false)
        })

    };

    const resetForm = () => {
        setFormData({
            employee_name: "",
            employee_code: "",
            mobile: "",
            username: "",
            password: "",
            password_confirmation: "",
            employee_id: ""
        });
        setShowPassword(false);
        setShowConfirmPassword(false);
        setIsSubmitting(false);
    };

    return (
        <div className="modal fade" id={modalID} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="hrmsactivationModalLabel">HRMs Activation</h5>
                        <button 
                            type="button" 
                            className="btn-close" 
                            data-bs-dismiss="modal" 
                            onClick={searchModalClose} 
                            aria-label="Close"
                        ></button>
                    </div>
                    <form id="hrmsactivationForm" onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm">
                                    Employee
                                </label>
                                <div className="col-sm-9">
                                    <input
                                        type="text"
                                        name="employee_name"
                                        className="form-control form-control-sm"
                                        placeholder="Employee"
                                        autoComplete="off"
                                        disabled={true}
                                        value={formData.employee_name}
                                    />
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm">
                                    Employee Code
                                </label>
                                <div className="col-sm-9">
                                    <input
                                        type="text"
                                        name="employee_code"
                                        className="form-control form-control-sm"
                                        placeholder="Employee Code"
                                        autoComplete="off"
                                        disabled={true}
                                        value={formData.employee_code}
                                    />
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm">
                                    Mobile Number
                                </label>
                                <div className="col-sm-9">
                                    <input
                                        type="text"
                                        name="mobile"
                                        className="form-control form-control-sm"
                                        placeholder="Mobile Number"
                                        autoComplete="off"
                                        disabled={true}
                                        value={formData.mobile}
                                    />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm require">
                                    Username
                                </label>
                                <div className="col-sm-9">
                                    <input
                                        type="text"
                                        name="username"
                                        className="form-control form-control-sm"
                                        placeholder="Enter username"
                                        autoComplete="off"
                                        required
                                        value={formData.username}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm require">
                                    Password
                                </label>
                                <div className="col-sm-9 position-relative">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        name="password"
                                        className="form-control form-control-sm"
                                        placeholder="Enter password"
                                        autoComplete="new-password"
                                        required
                                        value={formData.password}
                                        onChange={handleInputChange}
                                    />
                                    <span
                                        className="position-absolute"
                                        style={{ 
                                            right: '20px', 
                                            top: '50%', 
                                            transform: 'translateY(-50%)', 
                                            cursor: 'pointer',
                                            fontSize: '14px'
                                        }}
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? 
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faEyeSlash} /> : 
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faEye} />
                                        }
                                    </span>
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm require">
                                    Confirm Password
                                </label>
                                <div className="col-sm-9 position-relative">
                                    <input
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        name="password_confirmation"
                                        className="form-control form-control-sm"
                                        placeholder="Confirm password"
                                        autoComplete="new-password"
                                        required
                                        value={formData.password_confirmation}
                                        onChange={handleInputChange}
                                    />
                                    <span
                                        className="position-absolute"
                                        style={{ 
                                            right: '20px', 
                                            top: '50%', 
                                            transform: 'translateY(-50%)', 
                                            cursor: 'pointer',
                                            fontSize: '14px'
                                        }}
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    >
                                        {showConfirmPassword ? 
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faEyeSlash} /> : 
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faEye} />
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button 
                                type="button" 
                                className="btn btn-secondary" 
                                data-bs-dismiss="modal" 
                                onClick={searchModalClose}
                                disabled={isSubmitting}
                            >
                                Close
                            </button>
                            <button 
                                type="submit" 
                                form="hrmsactivationForm" 
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            > Submit
                                {isSubmitting && 
                                    <>
                                        <TapIcon.FontAwesomeIcon 
                                            icon={TapIcon.faSyncAlt} 
                                            className="fa-spin ms-2" 
                                        />
                                    </>
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
});

export default HrmActivationModal;